export default {
  namespaced: true,
  state: {
    isOpen: false,
    component: {}
  },
  getters: {
    isOpen (state: any) {
      return state.isOpen
    },
    component (state: any) {
      return state.component
    }
  },
  actions: {
    show (context: any, component: any) {
      context.commit('showed', component)
    },
    hide (context: any) {
      context.commit('hide')
    }
  },
  mutations: {
    showed (state: any, component: any) {
      state.isOpen = true
      state.component = component
    },
    hide (state: any) {
      state.isOpen = false
      state.component = {}
    }
  }
}
